var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileBuilderExternalid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.974,
    height: 46,
    viewBox: "0 0 45.974 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16",
    "data-name": "Layer 16",
    transform: "translate(0.005 0.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55656",
    "data-name": "Path 55656",
    d: "M1.7,14.356a1.842,1.842,0,0,1-.186-.01,1.706,1.706,0,0,1-1.51-1.882c.11-1.009.242-1.976.4-2.959V9.489A11.835,11.835,0,0,1,9.6.3h.017C10.6.137,11.565,0,12.574-.1a1.706,1.706,0,0,1,.367,3.393c-.94.1-1.843.225-2.758.377A7.947,7.947,0,0,0,6.045,5.936a7.969,7.969,0,0,0-2.27,4.138c-.152.913-.277,1.816-.377,2.755a1.706,1.706,0,0,1-1.7,1.527Z",
    transform: "translate(0 0)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55657",
    "data-name": "Path 55657",
    d: "M363.6,14.516a1.706,1.706,0,0,1-1.695-1.522c-.1-.941-.224-1.844-.376-2.757A7.945,7.945,0,0,0,359.261,6.1a7.94,7.94,0,0,0-4.138-2.27c-.915-.153-1.818-.276-2.758-.377a1.706,1.706,0,0,1,.367-3.393c1.008.109,1.976.242,2.959.4h.017a11.832,11.832,0,0,1,9.185,9.189v.017c.163.982.3,1.95.4,2.963a1.706,1.706,0,0,1-1.51,1.873A1.632,1.632,0,0,1,363.6,14.516Z",
    transform: "translate(-319.342 -0.146)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55658",
    "data-name": "Path 55658",
    d: "M352.563,365.491a1.706,1.706,0,0,1-.18-3.4c.942-.1,1.845-.225,2.757-.377a8.432,8.432,0,0,0,6.408-6.409c.152-.914.275-1.816.376-2.757a1.706,1.706,0,1,1,3.393.367c-.109,1.009-.242,1.976-.4,2.959v.017a11.823,11.823,0,0,1-9.185,9.184h-.016c-.982.163-1.95.3-2.963.4A1.84,1.84,0,0,1,352.563,365.491Z",
    transform: "translate(-319.358 -319.603)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55659",
    "data-name": "Path 55659",
    d: "M12.762,365.306a1.638,1.638,0,0,1-.186-.011c-1.01-.11-1.976-.242-2.959-.4H9.6A11.844,11.844,0,0,1,.416,355.7v-.017c-.166-.98-.3-1.947-.408-2.957a1.706,1.706,0,0,1,3.393-.367c.1.942.225,1.844.377,2.758a7.988,7.988,0,0,0,2.27,4.138,7.928,7.928,0,0,0,4.138,2.27c.914.152,1.816.276,2.758.377a1.706,1.706,0,0,1-.18,3.4Z",
    transform: "translate(-0.003 -319.43)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55660",
    "data-name": "Path 55660",
    d: "M146.5,280.984a44.018,44.018,0,0,1-7.549-.593,4.515,4.515,0,0,1-2.425-1.468,4.715,4.715,0,0,1-1.154-2.587v-.029a14.986,14.986,0,0,1-.065-2.084,10.3,10.3,0,0,1,.065-1.727v-.028a4.012,4.012,0,0,1,1.158-2.416,4.08,4.08,0,0,1,2.434-1.172c1.347-.143,5.452-.221,7.537-.221s5.433.078,6.781.221a4.078,4.078,0,0,1,2.434,1.172,4.012,4.012,0,0,1,1.158,2.417v.028a15.163,15.163,0,0,1,.1,1.725,19.859,19.859,0,0,1-.1,2.089v.028a4.717,4.717,0,0,1-1.156,2.589,4.528,4.528,0,0,1-2.425,1.468A40.6,40.6,0,0,1,146.5,280.984Z",
    transform: "translate(-123.15 -244.636)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2842",
    "data-name": "Ellipse 2842",
    cx: 6.519,
    cy: 6.519,
    r: 6.519,
    transform: "translate(16.328 9.42)",
    fill: "#387f75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBuilderExternalid);
export default __webpack_public_path__ + "static/media/profile-builder-externalid.8f27ecef411abecae6aa962076f05d58.svg";
export { ForwardRef as ReactComponent };